import React, { useEffect, useState } from "react";
import "./MainDetail.css";
import commenticon from "../../../Component/Images/commenticon.png";
import vector2 from "../../../Component/Images/vector2.png";
import contacticon from "../../../Component/Images/contacticon.png";
import mainimg from "../../../Component/Images/mainimg.png";
import footerimg from "../../../Component/Images/footerimg.png";
import { environmentVariables } from "../../../config/env.config";
import { useSearchParams } from "react-router-dom";
import axios from "axios";
import { formatDate } from "../../../Component/DateFormat/DateFormat";
import authorimg from '../../../Component/Images/3.png';

const MainDetail = ({ slug }) => {
  // const [searchParams] = useSearchParams();
  // const id = searchParams.get("id");
  const [blogPosts, setBlogPosts] = useState([]); // Ensure it's initialized as an array
  const [loading, setLoading] = useState(true);

  const fetchBlogsById = async () => {
    try {
      const response = await axios.get(
        `${environmentVariables?.apiUrlBlogs}api/v1/user/get-blog-by-slug?slug=${slug}&type=be`
      );

      console.log("Full API Response:", response);

      if (response?.data?.statusCode === 200) {
        console.log("Blogs Data:", response.data.data);
        setBlogPosts(response.data.data || []); // Ensure it's an array
      } else {
        console.error("API Error:", response.data?.message);
      }
    } catch (error) {
      console.error("Fetch Error:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchBlogsById();
  }, [slug]);

  if (loading) {
    return <div style={{ height: '100vh' }}>
      <div id="loader" class="loader"></div>;
    </div>;
  }

  return (
    <div className="MainDetail">
      <div className="top">
        <div className="topfirst">
          <img
            src={blogPosts?.image
              ? `${environmentVariables?.apiUrlBlogs}uploads/files/${blogPosts?.image}`
              : authorimg}

            alt="error"
          />
        </div>
        <div className="topsecond">
          <div className="blog-meta">
            <div className="imagee">
              <img  src={blogPosts?.image ? `${environmentVariables?.apiUrlBlogs}uploads/files/${blogPosts?.author?.profile_pic}` : footerimg} alt="error" />
            </div>
            <div className="textt">
              <h4>{blogPosts?.author?.name}</h4>
              <p>{blogPosts?.author?.tag}</p>
            </div>
          </div>
          <h5>{formatDate(blogPosts?.created_at) || 'Unknown Date'}</h5>
        </div>
      </div>
      <div className="bottom">
        <div className="text-container">
          <div className="text">
            <h2 dangerouslySetInnerHTML={{ __html: blogPosts?.heading }}>

            </h2>
            <p dangerouslySetInnerHTML={{ __html: blogPosts?.description }}>

            </p>
          </div>
          {/* <div className="text">
            <h2>
              Lorem Ipsum is simply dummy text of the printing and typesetting
              industry.
            </h2>
            <p>
              Lorem Ipsum is simply dummy text of the printing and typesetting
              industry. Lorem Ipsum has been the industry's standard dummy text
              ever since the 1500s, when an unknown printer took a galley of
              type and scrambled it to make a type specimen book. It has
              survived not only five centuries, but also the leap into
              electronic typesetting, remaining essentially unchanged. It was
              popularised in the 1960s with the release of Letraset sheets
              containing Lorem Ipsum passages, and more recently with desktop
              publishing software like Aldus PageMaker including versions of
              Lorem Ipsum.
            </p>
          </div>
          <div className="text">
            <h2>
              Lorem Ipsum is simply dummy text of the printing and typesetting
              industry.{" "}
            </h2>
            <p>
              Lorem Ipsum is simply dummy text of the printing and typesetting
              industry. Lorem Ipsum has been the industry's standard dummy text
              ever since the 1500s, when an unknown printer took a galley of
              type and scrambled it to make a type specimen book. It has
              survived not only five centuries, but also the leap into
              electronic typesetting, remaining essentially unchanged. It was
              popularised in the 1960s with the release of Letraset sheets
              containing Lorem Ipsum passages, and more recently with desktop
              publishing software like Aldus PageMaker including versions of
              Lorem Ipsum.
            </p>
          </div>
          <div className="text">
            <h2>
              Lorem Ipsum is simply dummy text of the printing and typesetting
              industry.{" "}
            </h2>
            <p>
              Lorem Ipsum is simply dummy text of the printing and typesetting
              industry. Lorem Ipsum has been the industry's standard dummy text
              ever since the 1500s, when an unknown printer took a galley of
              type and scrambled it to make a type specimen book.{" "}
              <span>
                It has survived not only five centuries, but also the leap into
                electronic typesetting, remaining essentially unchanged.
              </span>{" "}
              It was popularised in the 1960s with the release of Letraset
              sheets containing Lorem Ipsum passages, and more recently with
              desktop publishing software like Aldus PageMaker including
              versions of Lorem Ipsum.
            </p>
          </div>
          <div className="text">
            <h2>
              Lorem Ipsum is simply dummy text of the printing and typesetting
              industry.{" "}
            </h2>
            <p>
              Lorem Ipsum is simply dummy text of the printing and typesetting
              industry. Lorem Ipsum has been the industry's standard dummy text
              ever since the 1500s, when an unknown printer took a galley of
              type and scrambled it to make a type specimen book. It has
              survived not only five centuries, but also the leap into
              electronic typesetting, remaining essentially unchanged. It was
              popularised in the 1960s with the release of Letraset sheets
              containing Lorem Ipsum passages, and more recently with desktop
              publishing software like Aldus PageMaker including versions of
              Lorem Ipsum.
            </p>
            <p>
              Lorem Ipsum is simply dummy text of the printing and typesetting
              industry. Lorem Ipsum has been the industry's standard dummy text
              ever since the 1500s, when an unknown printer took a galley of
              type and scrambled it to make a type specimen book. It has
              survived not only{" "}
              <span>
                five centuries, but also the leap into electronic typesetting,
              </span>{" "}
              remaining essentially unchanged. It was popularised in the 1960s
              with the release of Letraset sheets containing Lorem Ipsum
              passages, and more recently with desktop publishing software like
              Aldus PageMaker including versions of Lorem Ipsum.
            </p>
          </div> */}
        </div>
        {/* <div className="blog-footer1">
          <div className="blog-cmnt">
            <label className="block font-medium mb-2">Comments:</label>
            <div style={{ position: "relative", marginTop: "10px" }}>
              <img src={commenticon} alt="error" />
              <textarea
                rows="4"
                placeholder="Write your comments here..."
              ></textarea>
            </div>
          </div>
        </div> */}
      </div>
      {/* <div className="bottomnew">
        <div className="text-first">
          <div className="top">
            <img src={contacticon} alt="error" />
            <h4>Amy Wilson</h4>
          </div>
          <div className="mid">
            <p>
              Lorem Ipsum is simply dummy text of the printing and typesetting
              industry. Lorem Ipsum has been the industry's standard dummy text
              ever since the 1500s, when an unknown printer took a galley of
              type and scrambled it to make a type specimen book. <br />
              <span>Thanks</span>
            </p>
          </div>
          <div className="bottom">
            <div className="replay">
              <img src={vector2} alt="error" />
              <p>Reply</p>
            </div>
          </div>
        </div>
        <div className="text-second">
          <div className="secondtext">
            <div className="top">
              <img src={contacticon} alt="error" />
              <h4>Amy Wilson</h4>
            </div>
            <div className="mid">
              <p>
                Lorem Ipsum is simply dummy text of the printing and typesetting
                industry. Lorem Ipsum has been the industry's standard dummy
                text ever since the 1500s, when an unknown printer took a galley
                of type and scrambled it to make a type specimen book. <br />
                <span>Thanks</span>
              </p>
            </div>
            <div className="bottom">
              <div className="replay">
                <img src={vector2} alt="error" />
                <p>Reply</p>
              </div>
            </div>
          </div>
        </div>
        <div className="text-first">
          <div className="top">
            <img src={contacticon} alt="error" />
            <h4>Amy Wilson</h4>
          </div>
          <div className="mid">
            <p>
              Lorem Ipsum is simply dummy text of the printing and typesetting
              industry. Lorem Ipsum has been the industry's standard dummy text
              ever since the 1500s, when an unknown printer took a galley of
              type and scrambled it to make a type specimen book. <br />
              <span>Thanks</span>
            </p>
          </div>
          <div className="bottom">
            <div className="replay">
              <img src={vector2} alt="error" />
              <p>Reply</p>
            </div>
          </div>
        </div>
        <div className="text-second">
          <div className="secondtext">
            <div className="top">
              <img src={contacticon} alt="error" />
              <h4>Amy Wilson</h4>
            </div>
            <div className="mid">
              <p>
                Lorem Ipsum is simply dummy text of the printing and typesetting
                industry. Lorem Ipsum has been the industry's standard dummy
                text ever since the 1500s, when an unknown printer took a galley
                of type and scrambled it to make a type specimen book. <br />
                <span>Thanks</span>
              </p>
            </div>
            <div className="bottom">
              <div className="replay">
                <img src={vector2} alt="error" />
                <p>Reply</p>
              </div>
            </div>
          </div>
        </div>
        <div className="text-second"></div>
      </div> */}
    </div>
  );
};

export default MainDetail;
